module.exports = {
  urls: {
    app: 'https://app.hackedu.com',
    blog: 'https://blog.hackedu.com',
    cdn: 'https://cdn.hackedu.io',
    control: 'https://control.hackedu.com',
    hacker: 'https://platform.hackedu.com/hacker/v1',
    quiz: 'https://platform.hackedu.com/quiz/v1',
    samy: 'https://samy.hackedu.com',
    testengine: 'https://platform.hackedu.com/test-engine/v1',
    www: 'https://www.hackedu.com',
  },
  aws: {
    region: 'us-east-1',
    identityPoolId: 'us-east-1:894aeb70-77ed-466b-bb83-88751ac73e55',
  },
  cognito: {
    authData: {
      ClientId: 'bg6jqljbdakuts5tu3jqhuph0',
      AppWebDomain: 'auth.hackedu.com',
      TokenScopesArray: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
      RedirectUriSignIn: 'https://app.hackedu.com/auth',
      RedirectUriSignOut: 'https://app.hackedu.com',
      UserPoolId: 'us-east-1_CHi5tsM8X',
      AdvancedSecurityDataCollectionFlag: false,
    },
  },
  saml: {
    checkDomainAssociationUri: 'https://platform.hackedu.com/auth/v1/domain',
  },
  segment: {
    key: 'Sy6SN194H3OATRfapSYABAcSBGFdIqyv',
  },
  stripe: {
    key: 'pk_live_Td7XbljbQAUjEsy1oF8x2v3y',
  },
}
